import { SanityVideoTeaserCard } from '../../types/generated/graphql-types'
import { VideoTeaserProps } from '../components/VideoTeaser'
import { sanityBasicBackgroundVideoToVideoTeaserPreviewImage } from './VideoMapper'

export const sanityVideoTeaserCardToVideoTeaserProps = (
  teaser: SanityVideoTeaserCard
): VideoTeaserProps => ({
  buttonLabel: teaser.buttonLabel ?? undefined,
  description: teaser.description ?? undefined,
  previewImage: teaser.previewVideo
    ? sanityBasicBackgroundVideoToVideoTeaserPreviewImage(teaser.previewVideo)
    : undefined,
  previewVideoUrl: teaser.previewVideo?.url ?? undefined,
  title: teaser.title ?? '',
  videoUrl: teaser.video?.url ?? undefined,
  videoControls: teaser.videoControls ?? false,
  orientation: teaser?.videoLeft ? 'video-left' : 'video-right',
  showVideoModalButton: !(teaser?.hideModalButton ?? true),
})
